/**
 * Apollo operation context for a public, optional request such as the hybrid login rollout control
 * (#4193). The shared links in `apollo.ts` honor it:
 *
 * - `authLink` sends no credentials and does not touch the session (no renewal, no expiry check), so
 *   a public request never carries a token or ends a session.
 * - `handleErrorLink` leaves its failures to the caller: no connection notification, no monitoring
 *   event and no sign-out, so a failed optional request never changes the page.
 *
 * Kept free of imports so auth code can use it without importing the Apollo client module.
 */
export const PUBLIC_OPTIONAL_OPERATION_CONTEXT = { publicOptionalOperation: true } as const;

export function isPublicOptionalOperation(context: Record<string, unknown> | undefined): boolean {
  return context?.publicOptionalOperation === true;
}
